import {
  type AlertProps as MuiAlertProps,
  Typography,
  alertClasses,
  styled,
  useTheme,
} from "@mui/material"
import { Bell } from "react-feather"
import { AlertIconContainer } from "../../icons"
import { Alert } from "../Alert"

export type BellAlertBannerProps = Omit<
  MuiAlertProps,
  "icon" | "severity" | "variant"
>

export const BellAlertBanner = ({ children, ...props }: BellAlertBannerProps) => {
  const {
    palette: { common },
  } = useTheme()
  return (
    <StyledAlert
      {...props}
      severity="warning"
      variant="standard"
      icon={
        <AlertIconContainer
          color={common.orangeDark2}
          slotProps={{ dotIcon: { color: common.electricBlue } }}
        >
          <Bell size={20} />
        </AlertIconContainer>
      }
    >
      <Message>{children}</Message>
    </StyledAlert>
  )
}

const StyledAlert = styled(Alert)(({ theme: { palette } }) => ({
  color: palette.common.black,
  "&.MuiPaper-root": {
    backgroundColor: `color-mix(in srgb, ${palette.warning.main} 19%, #fff)`,
  },
  [`& .${alertClasses.message}, & .${alertClasses.icon}`]: {
    display: "flex",
    alignItems: "center",
  },
}))

const Message = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
}))
